// extracted by mini-css-extract-plugin
export var btnFacebook = "compareCheckBox-module--btn-facebook--b5eeb";
export var btnLinkedin = "compareCheckBox-module--btn-linkedin--669b6";
export var btnWechat = "compareCheckBox-module--btn-wechat--a97b8";
export var btnXing = "compareCheckBox-module--btn-xing--c17f3";
export var btnYoutube = "compareCheckBox-module--btn-youtube--99cc5";
export var compareCheckContainer = "compareCheckBox-module--compareCheckContainer--90d90";
export var icon = "compareCheckBox-module--icon--6dadf";
export var iconText = "compareCheckBox-module--icon-text--39514";
export var mail = "compareCheckBox-module--mail--448bf";
export var phone = "compareCheckBox-module--phone--fa3a6";
export var printer = "compareCheckBox-module--printer--323ac";